import React, { memo } from 'react';
import PropTypes from 'prop-types';

import paths from 'app/paths';
import { ViewLinkButton } from 'components';

const TransactionActionsCell = memo((props) => {
  const {
    item: { id },
  } = props;
  return <ViewLinkButton to={paths.transactionView.path} params={{ id }} />;
});

TransactionActionsCell.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default TransactionActionsCell;
